import {
    Badge,
    Box,
    Button,
    Spinner,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useToast
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { getShipments } from "../../api";
import AccessDenied from "../../components/AccessDenied";
import TitleHeader from "../../components/TitleHeader";
import { hasPermission } from "../../Utils";
import AddNoteModal from "./AddNoteModal";
import AddShipmentModal from "./AddShipmentModal";
import ViewShipmentModal from "./ViewShipmentModal";

const ShipmentsList = () => {
    const [shipments, setShipments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
    const [selectedShipment, setSelectedShipment] = useState(null);

    const toast = useToast();

    useEffect(() => {
        fetchShipments();
    }, []);

    const fetchShipments = async () => {
        setLoading(true);
        try {
            const response = await getShipments();

            if (response.success) {
                setShipments(response.data);
            } else {
                setShipments([]);
            }
        } catch (error) {
            toast({ title: "Error fetching shipments", status: "error" });
        }
        setLoading(false);
    };

    if (!hasPermission('viewShipments')) {
        return <AccessDenied msg={"You don't have permission to view this page"} />;
    }

    return (
        <Box p={5}>
            <TitleHeader title="Sendout Equipments" buttonText={"Add Equipment"} onClick={() => setIsModalOpen(true)} />

            {loading ? <Spinner size="xl" /> : (
                shipments.length > 0 ? (
                    <Table size="sm">
                        <Thead>
                            <Tr>
                                <Th>Client</Th>
                                <Th>Items</Th>
                                <Th>Actions</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {shipments.map((shipment, index) => (
                                <Tr
                                    borderBottom={"2px solid #82a4b5"}
                                    _hover={{
                                        bg: '#a3a3a3',
                                        color: 'white'
                                    }}
                                    bg={index % 2 == 0 ? 'gray.100' : 'white'}
                                    key={shipment._id}
                                >
                                    <Td>
                                        <Box mb={1}>
                                            <Text mb={3} fontWeight={'bold'}>{shipment.clientName}</Text>
                                            <Text mb={3} color={'grey'} fontSize={'xs'}>{shipment.clientAddress || "N/A"}</Text>
                                            <Text mb={3} color={'grey'} fontSize={'xs'}>Shipped At {new Date(shipment.shippedAt).toLocaleString()}</Text>
                                            <Text mb={3} color={'grey'} fontSize={'xs'}>Last Update {shipment.updateAt ? new Date(shipment.updateAt).toLocaleString() : "N/A"}</Text>

                                        </Box>
                                    </Td>
                                    {/* <Td>{shipment.clientAddress || "N/A"}</Td> */}
                                    <Td>
                                        {shipment.items.map((item, index) => (
                                            <Box style={{ borderBottom: "1px solid #ccc", paddingBottom: '10px', paddingTop: '10px' }} key={index} mb={1}>
                                                <b>#{index + 1} </b>{item.equipmentName} - {item.serialNumber}
                                                <Badge colorScheme={item.returned ? "green" : "red"} ml={2}>
                                                    {item.returned ? "Returned" : "Not Returned"}
                                                </Badge>
                                            </Box>
                                        ))}
                                    </Td>
                                    <Td>
                                        <Button size="xs" onClick={() => { setSelectedShipment(shipment); setIsNoteModalOpen(true); }}>
                                            Add Note
                                        </Button>

                                        <Button size="xs" colorScheme={'green'} ml={4} onClick={() => { setSelectedShipment(shipment); }}>
                                            View
                                        </Button>


                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                ) : (
                    <Box mt={10} textAlign="center">
                        <AccessDenied msg="No shipments yet" />
                    </Box>
                )
            )}



            <ViewShipmentModal
                isOpen={!!selectedShipment}
                onClose={() => setSelectedShipment(null)}
                shipment={selectedShipment}
                refreshShipments={fetchShipments}
            />

            <AddShipmentModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
            <AddNoteModal isOpen={isNoteModalOpen} shipment={selectedShipment} onClose={() => setIsNoteModalOpen(false)} />
        </Box>
    );
};

export default ShipmentsList;
